module.exports = __webpack_public_path__ + "img/pt.54f7b6e2.png";